import { DateService } from "@/core/services/Date.service";
import { DateAdapter } from "@/infrastructure/adapters/dayJs";

interface IIntelliUploadQueueHistory {
  queueId: number;
  processId: string;
  isQueueCompleted: boolean;
  isRuleTriggered: boolean;
  createdAt: string;
  documentsCount: number;
  status: string;
}

export class IntelliUploadQueueHistory implements IIntelliUploadQueueHistory {
  private readonly _queueId: number;
  private readonly _processId: string;
  private _isQueueCompleted: boolean;
  private _isRuleTriggered: boolean;
  private readonly _createdAt: string;
  private readonly _documentsCount: number;
  private _status: string;

  constructor(props: IIntelliUploadQueueHistory) {
    this._queueId = props.queueId;
    this._processId = props.processId;
    this._isQueueCompleted = props.isQueueCompleted;
    this._isRuleTriggered = props.isRuleTriggered;
    this._createdAt = props.createdAt;
    this._documentsCount = props.documentsCount;
    this._status = props.status;
  }

  public get queueId(): number {
    return this._queueId;
  }

  public get processId(): string {
    return this._processId;
  }

  public set isQueueCompleted(value: boolean) {
    this._isQueueCompleted = value;
  }

  public get isQueueCompleted(): boolean {
    return this._isQueueCompleted;
  }

  public get isRuleTriggered(): boolean {
    return this._isRuleTriggered;
  }

  public set isRuleTriggered(value: boolean) {
    this._isRuleTriggered = value;
  }

  public get createdAt(): string {
    return this._createdAt;
  }

  public createdAtFormatted(format: string): string {
    return new DateService(new DateAdapter()).format(this._createdAt, format);
  }

  public get documentsCount(): number {
    return this._documentsCount;
  }

  public get status(): string {
    return this._status;
  }

  public set status(value: string) {
    this._status = value;
  }
}
